import React from 'react';
import { motion } from 'framer-motion';
import { FiDownload, FiRefreshCw, FiCheck } from 'react-icons/fi';
import './ResultDisplay.css';

const ResultDisplay = ({ 
  originalImage, 
  processedImage, 
  onDownload, 
  onReset,
  downloadFileName = 'processed-image.png',
  showComparison = true
}) => {
  return (
    <motion.div 
      className="result-display"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="result-header">
        <div className="success-badge">
          <FiCheck /> Processing Complete
        </div>
      </div>

      {showComparison && originalImage ? (
        <div className="comparison-view">
          <div className="comparison-item">
            <h4 className="comparison-label">Original</h4>
            <div className="comparison-image">
              <img src={originalImage} alt="Original" />
            </div>
          </div>
          
          <div className="comparison-arrow">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <circle cx="20" cy="20" r="20" fill="url(#arrow-gradient)"/>
              <path d="M15 20H25M25 20L21 16M25 20L21 24" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <defs>
                <linearGradient id="arrow-gradient" x1="0" y1="0" x2="40" y2="40">
                  <stop offset="0%" stopColor="#667eea"/>
                  <stop offset="100%" stopColor="#764ba2"/>
                </linearGradient>
              </defs>
            </svg>
          </div>
          
          <div className="comparison-item">
            <h4 className="comparison-label result">Result</h4>
            <div className="comparison-image result">
              <img src={processedImage} alt="Processed" />
            </div>
          </div>
        </div>
      ) : (
        <div className="single-result">
          <div className="result-image">
            <img src={processedImage} alt="Processed" />
          </div>
        </div>
      )}

      <div className="result-actions">
        <motion.button 
          className="action-btn primary"
          onClick={onDownload}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <FiDownload />
          Download Image
        </motion.button>
        
        <motion.button 
          className="action-btn secondary"
          onClick={onReset}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <FiRefreshCw />
          Process Another
        </motion.button>
      </div>
    </motion.div>
  );
};

export default ResultDisplay;
